// @ts-check
import Vue from 'vue';
import { BETSLIP_SETTINGS } from 'bto-models/betslip/const';
import Acumulator from 'bto-models/betslip/bonuses/acumulator-model';
import { roundAmount, setRoundingDigits } from './helpers';

function mapSettings(settings = {}, excangeRate = 1) {
  return {
    MAX_ITEMS: +settings[BETSLIP_SETTINGS.MAX_OUTCOMES_COUNT] || 20,
    MAX_LINES: +settings[BETSLIP_SETTINGS.MAX_COMBS] || 2048,
    MULTIPLE_SAME_MATCH_MARKETS: settings[BETSLIP_SETTINGS.MULTIPLE_SAME_MATCH_MARKETS] === 'false',
    MAX_MATCH_COUNT: +settings[BETSLIP_SETTINGS.MAX_GAMES_COUNT],
    MIN_BET_AMOUNT: +roundAmount((+settings[BETSLIP_SETTINGS.MIN_BET_AMOUNT] || 0) / excangeRate),
    MAX_BET_AMOUNT: +roundAmount((+settings[BETSLIP_SETTINGS.MAX_BET_AMOUNT] || Infinity) / excangeRate),
    MIN_LINE_AMOUNT: +roundAmount((+settings[BETSLIP_SETTINGS.MIN_LINE_AMOUNT] || 0) / excangeRate),
    MAX_LINE_AMOUNT: +roundAmount((+settings[BETSLIP_SETTINGS.MAX_LINE_AMOUNT] || Infinity) / excangeRate),
    BET_BUILDER_MARKET_ID: +settings[BETSLIP_SETTINGS.BET_BUILDER_MARKET_ID] || 0,
    BET_BUILDER_OUTCOME_ID: +settings[BETSLIP_SETTINGS.BET_BUILDER_OUTCOME_ID] || 0,
    SPORTCAST_API_URL: settings[BETSLIP_SETTINGS.SPORTCAST_API_URL] || '',
    BET_BUILDER_API_KEY: settings[BETSLIP_SETTINGS.BET_BUILDER_API_KEY] || '',
    ADD_STAKE_TAX: settings[BETSLIP_SETTINGS.ADD_STAKE_TAX] === 'true',
    BET_BUILDER_SWISH_MARKET_ID: +settings[BETSLIP_SETTINGS.BET_BUILDER_SWISH_MARKET_ID] || 0,
    BET_BUILDER_SWISH_OUTCOME_ID: +settings[BETSLIP_SETTINGS.BET_BUILDER_SWISH_OUTCOME_ID] || 0,
    NO_BOOSTED_IN_FREEBETS: settings[BETSLIP_SETTINGS.NO_BOOSTED_IN_FREEBETS] === 'true',
    NO_MULTIPLE_RACE_MATCH: settings[BETSLIP_SETTINGS.ONLY_SINGLES_FCTC] === 'true',
    ALGO_ENABLED: settings[BETSLIP_SETTINGS.ALGO_ENABLED] === 'true',
    ALGO_MARKET_ID: +settings[BETSLIP_SETTINGS.ALGO_MARKET_ID] || 0,
    ALGO_OUTCOME_ID: +settings[BETSLIP_SETTINGS.ALGO_OUTCOME_ID] || 0,
  };
}

/**
 * Get rouding digits for user currency, default to 2
 * @param {Partial<import('bto-models/sb-settings/interfaces').SBSettings>} rawSettings 
 */
function getRoundingDigits(rawSettings) {
  const currency = rawSettings.playerCurrency;
  if (rawSettings.RoundDec[currency]) {
    return Math.max(rawSettings.RoundDec[currency].rd, 0);
  }
  return 2;
}

/**
 * Get excange rate for user currency, default to 1 (system currency selected)
 * @param {Partial<import('bto-models/sb-settings/interfaces').SBSettings>} rawSettings 
 */
function getExcangeRate(rawSettings) {
  if (rawSettings.RoundDec[rawSettings.playerCurrency]) {
    return +rawSettings.RoundDec[rawSettings.playerCurrency].e || 1;
  }
  return 1;
}

/**
 * Get default state for error store 
 */
const getDefaultState = () => ({
  settings: mapSettings(),
  accumulatorBonus: new Acumulator({}),
});

export const configStore = Vue.observable(getDefaultState());

/**
 * Set config store settings from SB Rest api reposnse
 * @param {Partial<import('bto-models/sb-settings/interfaces').SBSettings>} rawSettings - raw settings object
 */
export const setBetslipSettings = (rawSettings = { RoundDec: {}, Settings: {} }) => {
  const roundDigits = getRoundingDigits(rawSettings);
  const excangeRate = getExcangeRate(rawSettings);
  setRoundingDigits(roundDigits);
  const settings = mapSettings(rawSettings.Settings, excangeRate);
  Object.assign(configStore, {
    settings
  });
};

/**
 * Set accumulator bonus in store
 * @param {*} data - raw data from REST api
 */
export const setAccumulatorBonus = (data) => {
  const accumulatorBonus = new Acumulator(data);
  Object.assign(configStore, {
    accumulatorBonus,
  });
};

/**
 * Set stake limits by player currency
 * @param {import('bto-models/sb-settings/interfaces').TGetLimitsByCurrencies[]} limits - limits list
 */
export function setLimitByCurrency(limits) {
  if (!limits) {
    return;
  }
  const limit = limits.find(l => l.CurrencyCode === APP_SETTINGS.player.currency);
  if (limit) {
    configStore.settings.MAX_LINE_AMOUNT = limit.MaxBetAmountPerCombi;
    configStore.settings.MIN_LINE_AMOUNT = limit.MinBetAmountPerCombi;
    configStore.settings.MAX_BET_AMOUNT = limit.MaxBetAmount;
    configStore.settings.MIN_BET_AMOUNT = limit.MinBetAmount;
  }
} 